// Web Component to load a different video file on mobile than desktop
if (!customElements.get('mobile-specific-video')) {
class MobileSpecificVideo extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.boundSourceSelector = this.sourceSelector.bind(this);
    this.boundResize = this.debounce(this.boundSourceSelector, 100);
    this.boundHandlePlaying = this.handlePlaying.bind(this);
    this.boundTryPlay = this.tryPlay.bind(this);
  }

  connectedCallback() {
    if (!this.video) return;

    this.setupListeners();
    this.sourceSelector();
  }

  disconnectedCallback() {
    this.teardownListeners();
  }

  setupListeners() {
    window.addEventListener('resize', this.boundResize);
    document.addEventListener('shopify:section:load', this.boundSourceSelector);
    this.video.addEventListener('playing', this.boundHandlePlaying);
    this.video.addEventListener('canplay', this.boundTryPlay);
  }

  teardownListeners() {
    window.removeEventListener('resize', this.boundResize);
    document.removeEventListener('shopify:section:load', this.boundSourceSelector);
    this.video.removeEventListener('playing', this.boundHandlePlaying);
    this.video.removeEventListener('canplay', this.boundTryPlay);
  }

  sourceSelector() {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;
    const breakpoint = parseInt(this.getAttribute('data-breakpoint'), 10) || 1023;

    const src = windowWidth > breakpoint ? this.getAttribute('data-desktop-vid') : this.getAttribute('data-mobile-vid');
    if (!src || this.video.dataset.currentSelection === src) return;
    const source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';

    this.removeAttribute('data-playing');
    this.style.opacity = '0';
    this.video.pause();
    this.video.muted = true;
    this.video.playsInline = true;
    this.video.innerHTML = '';
    this.video.appendChild(source);
    this.video.dataset.currentSelection = src;
    this.video.load();

    this.tryPlay();
  }

  tryPlay() {
    const playPromise = this.video.play();
    if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
  }

  handlePlaying() {
    this.setAttribute('data-playing', '');
    this.style.opacity = '1';
  }

  debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

  customElements.define('mobile-specific-video', MobileSpecificVideo);
}
